import { Partner } from 'partners/Partner';
import { getCurrentPartner } from 'utils/getCurrentPartner';

/**
 * @template R
 * @description Function which return standard or partner resource.
 * @param {R} standardResource - Standard app resource.
 * @param {Partial<Record<Partner, R>>} partnerResourceMap - Partner resources Mapping.
 * @returns {R} Standard or partner resource.
 */
export function getPartnerResource<R>(
    standardResource: R,
    partnerResourceMap: Partial<Record<Partner, R>>,
): R {
    const currentPartner = getCurrentPartner();

    if (!currentPartner) {
        return standardResource;
    }

    const partnerResource = partnerResourceMap[currentPartner];

    return partnerResource || standardResource;
}
